export type SupportedLanguage = 'zh-TW' | 'en'

export interface LanguagePolicy {
  readonly language?: SupportedLanguage
  readonly detectionOrder: string[]
  readonly caches: string[]
}

/**
 * Embedded routes follow the Shopify Admin user locale and never inherit a
 * browser or public-site preference. Other frontend surfaces retain the
 * existing browser-detected, locally persisted language choice.
 */
export function resolveLanguagePolicy(
  surface: string | null | undefined,
  shopifyAdminLocale: string | undefined,
): LanguagePolicy {
  if (surface === 'app') {
    return {
      language: shopifyAdminLocale?.toLowerCase().startsWith('zh') ? 'zh-TW' : 'en',
      detectionOrder: [],
      caches: [],
    }
  }

  return {
    detectionOrder: ['localStorage', 'navigator'],
    caches: ['localStorage'],
  }
}
